var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"sidebar-toggle",attrs:{"href":"#","data-toggle":"push-menu","role":"button"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")])])
}]

export { render, staticRenderFns }